import {
  all, call, put, takeLatest,
} from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import showNotification from 'services/utils/showNotification';
import {
  getStartupTeamMemberById,
  getAngelInvestorMemberById,
  getTechnicalLicenseMemberById,
} from 'packages/people_repository'
import { IdPayload } from 'types/reduxTypes/ActionTypes';
import { identity } from 'utils';
import {
  setMemberById,
  types,
} from '../../actions/memberDetails';

import {
  types as typesAC,
} from '../../actions/angelInvestorMemberDetails';

import {
  types as typesThlAC,
} from '../../actions/technicalLicenseMemberDetails'

export function * handleGetMemberById(action: PayloadAction<IdPayload>) {
  const { id } = action.payload;

  const { data: member, error, httpStatus } = yield call(getStartupTeamMemberById, id);

  if (identity.isObjWithChildren(error)) {
    showNotification(`Something went wrong: ${error.message}`, true, httpStatus);
  }

  yield put(setMemberById({ member }));
}

export function * handleGetAngelInvestorMemberById(action: PayloadAction<IdPayload>) {
  const { id } = action.payload;

  const { data: member, error, httpStatus } = yield call(getAngelInvestorMemberById, id);

  if (identity.isObjWithChildren(error)) {
    showNotification(`Something went wrong: ${error.message}`, true, httpStatus);
  }

  yield put(setMemberById({ member }));
}

export function * handleGetTechnicalLicenseMemberById(action: PayloadAction<IdPayload>) {
  const { id } = action.payload;

  const { data: member, error, httpStatus } = yield call(getTechnicalLicenseMemberById, id);

  if (identity.isObjWithChildren(error)) {
    showNotification(`Something went wrong: ${error.message}`, true, httpStatus);
  }

  yield put(setMemberById({ member }));
}

export default function * memberDetailsSagas() {
  yield all([
    takeLatest(types.GET_MEMBER_BY_ID, handleGetMemberById),
    takeLatest(typesAC.GET_ANGEL_INVESTOR_MEMBER_BY_ID, handleGetAngelInvestorMemberById),
    takeLatest(typesThlAC.GET_TECHNICAL_LICENSE_MEMBER_BY_ID, handleGetTechnicalLicenseMemberById),
  ]);
}
